// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取微盟账号 GET /weimob/get-wid */
export async function weimobGetWidUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultWeimobUserResp>('/weimob/get-wid', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取我的订单积分活动领取列表 GET /weimob/order-point/list */
export async function weimobOrderPointListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListMyOrderPointActivityResp>('/weimob/order-point/list', {
    method: 'GET',
    ...(options || {}),
  });
}
